import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Footer = () => (
  <FooterContainer>
    <FooterInner>
      <Copy>&copy; {new Date().getFullYear()} Dmitri Malisev</Copy>
      <FooterLinks>
        <FooterLink to="/contact">Contact</FooterLink>
        <FooterA href="https://github.com/mlsvd" target="_blank" rel="noopener noreferrer">GitHub</FooterA>
      </FooterLinks>
    </FooterInner>
  </FooterContainer>
);

const FooterContainer = styled.footer`
  border-top: 1px solid var(--border);
  margin-top: 4rem;
`;

const FooterInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 1.25rem 1rem;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const Copy = styled.span`
  font-size: 0.8125rem;
  color: var(--text-muted);
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const FooterLink = styled(Link)`
  font-size: 0.8125rem;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.15s;
  &:hover { color: var(--text-primary); }
`;

const FooterA = styled.a`
  font-size: 0.8125rem;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.15s;
  &:hover { color: var(--text-primary); }
`;

export default Footer;
